import { useCallback } from 'react'

import { useState } from 'react'

export default () => {
  const [open, setOpen] = useState(false)
  const openDialog = useCallback(() => {
    setOpen(true)
  }, [])
  const closeDialog = useCallback(() => {
    setOpen(false)
  }, [])
  return { open, openDialog, closeDialog }
}
